import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "../../../programs.css";
import sampleImage from "../../../Image/faq.jpg";

const newsData = [
  {
    title: "Which programming languages are used in embedded systems?",
    category: "Technology",
    description:
      "Embedded systems primarily use C and C++ because of their efficiency and hardware-level control. Python and Assembly are used in special cases, while Embedded C remains the most widely used language across microcontrollers.",
  },
  {
    title: "What kind of projects do embedded learners build?",
    category: "Trending",
    description:
      "Learners build projects like home automation systems, robotics controls, sensor-based monitoring devices, IoT systems, motor drivers, and communication-based devices. These projects help understand real-time data processing, microcontroller logic, and hardware-software integration.",
  },
  {
    title: "What job roles are available in the embedded field?",
    category: "Design",
    description:
      "Job roles include Embedded Engineer, Firmware Developer, Hardware Engineer, IoT Engineer, Microcontroller Programmer, Robotics Engineer, and Embedded Tester. These positions focus on system design, firmware logic, debugging, and hardware integration.",
  },
  {
    title: "How do embedded systems relate to IoT?",
    category: "Design",
    description:
      "Embedded systems act as the core of IoT devices by controlling sensors and processing real-time data. IoT adds connectivity layers like Wi-Fi, Bluetooth, or LoRa, enabling remote monitoring and automation.",
  },
  {
    title: "Can embedded systems operate without an operating system?",
    category: "Design",
    description:
      "Yes. Many embedded devices run without an OS using bare-metal programming. This approach provides full control of timing and performance, making it ideal for simple, low-power, or real-time applications.",
  },
];

const FAQ = () => {
  const [expandedIndex, setExpandedIndex] = useState(null);

  const toggleDescription = (i) => {
    setExpandedIndex(expandedIndex === i ? null : i);
  };

  return (
    <div className="faq-wrapper">
      <motion.h2
        className="faq-heading"
        initial={{ opacity: 0, y: -20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        FAQ — Frequently Asked Questions
      </motion.h2>
      <div className="news-section-container">
        <motion.div
          className="news-left-image"
          initial={{ opacity: 0, rotateY: -90 }}
          whileInView={{ opacity: 1, rotateY: 0 }}
          transition={{
            duration: 0.9,
            ease: "easeOut",
            delay: 0.2,
          }}
          viewport={{ once: false, amount: 0.4 }}
        >
          <img src={sampleImage} alt="Main Preview" />
        </motion.div>

        <motion.div
          className="news-right-list"
          initial={{ opacity: 0, scale: 0.8, y: 40 }}
          whileInView={{ opacity: 1, scale: 1, y: 0 }}
          transition={{
            duration: 0.8,
            ease: "easeOut",
            delay: 0.3,
          }}
          viewport={{ once: false, amount: 0.3 }}
        >
          {newsData.map((item, index) => (
            <motion.div
              key={index}
              className="news-item"
              whileHover={{ x: 10, backgroundColor: "#eefef6" }}
              transition={{ duration: 0.3 }}
              onClick={() => toggleDescription(index)}
            >
              <div className="row">
                <div className="title">{item.title}</div>

                {/* <div className="category">{item.category}</div> */}

                <motion.div
                  animate={{ rotate: expandedIndex === index ? 90 : 0 }}
                  transition={{ duration: 0.3 }}
                  className="arrow"
                >
                  ➤
                </motion.div>
              </div>

              <AnimatePresence>
                {expandedIndex === index && (
                  <motion.div
                    className="card-description"
                    layout
                    initial={{ opacity: 0, maxHeight: 0 }}
                    animate={{ opacity: 1, maxHeight: 800 }}
                    exit={{ opacity: 0, maxHeight: 0 }}
                    transition={{
                      duration: 0.45,
                      ease: "easeInOut",
                    }}
                  >
                    {item.description}
                  </motion.div>
                )}
              </AnimatePresence>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </div>
  );
};

export default FAQ;
